import CommonShare from '@xfe/common-share';
import didMount from '@src/components/hoc/did-mount';
import { validIpAddressRegex } from '@src/constants/regex';

const commonShare = new CommonShare();

/**
 * 自定义微信分享
 * @param shareParams
 */
export function share(shareParams) {
  const { hostname } = window.location;
  if (hostname !== 'localhost' && !validIpAddressRegex.test(hostname)) {
    commonShare.run(shareParams, { disableValidateShareParams: true });
  } else {
    console.warn('分享仅在代理host、测试或正式环境生效');
  }
}

/**
 * shareParams - 分享参数, 如:
 * @example
 * @wxShare({
 *  title: '剑侠世界手游，关注赢取小米MIX',
 *  $link: window.location.href,
 *  imgUrl: 'http://js.xoyo.com/zt/2016/10/operate/share.jpg',
 *  desc: '剑侠世界手游版 - 一生不可错过的浪漫武侠',
 *  swapTitleInWX: true
 * })
 * export default XXX extends React.Component...
 */
const qqwxShare = didMount(share);

export default qqwxShare;
